import { Box, Grid, useTheme, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { DateTimePicker } from "components";
import SectionHeader from "./SectionHeader";
import FieldLabel from "./FieldLabel";

const inputSx = {
  borderRadius: 1,
  "& .MuiOutlinedInput-input": {
    py: "10px",
    px: 1.5,
    fontSize: 14,
  },
};

const BasicShipmentDetails = ({
  formData,
  onChangeField,
  showDropCity = false,
  onChangeDropCity,
}) => {
  const theme = useTheme();
  return (
    <Box mb={3}>
      <Box sx={{ display: "flex" }}>
        <SectionHeader stepNumber={2} title="Shipment Details" />
        <FieldLabel title="" />
      </Box>

      <Box
        sx={{
          border: `1px solid ${theme.palette.grey["400"]}`,
          borderRadius: 2,
          padding: 3,
          mb: 3,
        }}
      >
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={6} md={showDropCity ? 3 : 4}>
            <FieldLabel title="Created By" isRequired={false} />
            <TextField
              fullWidth
              size="small"
              value={formData.createdBy || ""}
              onChange={(e) => onChangeField("createdBy", e.target.value)}
              placeholder="e.g. user@jsw.in"
              disabled
              sx={inputSx}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={showDropCity ? 3 : 4}>
            <FieldLabel title="Invoice Number" isRequired={false} />
            <TextField
              fullWidth
              size="small"
              value={formData.invoiceNumber || ""}
              onChange={(e) => onChangeField("invoiceNumber", e.target.value)}
              placeholder="e.g. INV-8956743.."
              sx={inputSx}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={showDropCity ? 3 : 4}>
            <FieldLabel
              title="Planned Dispatch Date & Time"
              isRequired={false}
            />
            <DateTimePicker
              value={formData.plannedDispatchDate || null}
              onChange={(val) => onChangeField("plannedDispatchDate", val)}
              inputFormat="dd MMM yyyy, hh:mm a"
              dateStyle={{
                width: "100%",
                ...inputSx,
              }}
            />
          </Grid>

          {showDropCity && (
            <Grid item xs={12} sm={6} md={3}>
              <FieldLabel title="Drop City" isRequired={true} />
              <TextField
                fullWidth
                size="small"
                value={formData.addressPickupAndDrop?.drop?.city || ""}
                onChange={(e) => onChangeDropCity?.(e.target.value)}
                placeholder="Enter Drop City"
                sx={inputSx}
              />
            </Grid>
          )}
        </Grid>

        <Box mt={3}>
          <Typography
            sx={{
              fontSize: 17,
              fontWeight: 600,
              mb: 2,
              ml: 1,
            }}
          >
            Delivery Time Window
          </Typography>

          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6} md={4}>
              <FieldLabel title="Start" isRequired={false} />
              <DateTimePicker
                value={formData.deliveryTimeWindow?.start || null}
                onChange={(val) =>
                  onChangeField("deliveryTimeWindow", {
                    ...formData.deliveryTimeWindow,
                    start: val,
                  })
                }
                inputFormat="dd MMM yyyy, hh:mm a"
                dateStyle={{
                  width: "100%",
                  ...inputSx,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FieldLabel title="End" isRequired={false} />
              <DateTimePicker
                value={formData.deliveryTimeWindow?.end || null}
                onChange={(val) =>
                  onChangeField("deliveryTimeWindow", {
                    ...formData.deliveryTimeWindow,
                    end: val,
                  })
                }
                inputFormat="dd MMM yyyy, hh:mm a"
                dateStyle={{
                  width: "100%",
                  ...inputSx,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FieldLabel title="ETA" isRequired={false} />
              <DateTimePicker
                value={formData.ETA || null}
                onChange={(val) => onChangeField("ETA", val)}
                inputFormat="dd MMM yyyy, hh:mm a"
                dateStyle={{
                  width: "100%",
                  ...inputSx,
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

BasicShipmentDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  showDropCity: PropTypes.bool,
  onChangeDropCity: PropTypes.func,
};

export default BasicShipmentDetails;
